import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Row, Spinner } from 'reactstrap'
import Dropzone from 'react-dropzone'
import ExclamationCircle from '../../images/exclamation-circle-icon.svg'
import UploadIcon from '../../images/upload-icon.svg'
import './LogoUpload.scss'

const LogoUpload = () => {
  const [file, setFile] = useState({})
  const [uploadedFileUrl, setUploadedFileUrl] = useState('')
  const [error, setError] = useState('')
  const [isBusy, setIsBusy] = useState(false)

  const onDropHandler = async (file) => {
    setIsBusy(true)
    const currentFile = file[0];
    const fileSize = (currentFile.size / (1024 * 1024)).toFixed(2);
    const validMimeTypes = [
      'image/jpeg', 'image/png', 'image/gif',
    ];

    if (!validMimeTypes.includes(currentFile.type)) {
      setError('Not supported file')
      return;
    }

    if (fileSize > 10) {
      setError('File size must be up to 10MB')
      return;
    }

    const formData = new FormData();
    formData.append('logo', currentFile);

    const response = await fetch('/add_company_logo', {
      method: 'POST',
      body: formData
    })

    response.json().then((result) => {
      if (response.status === 200) {
        setError('')
      } else {
        setError(result.error)
      }
    }).then(() => {
      setIsBusy(false)
    })

    setUploadedFileUrl(URL.createObjectURL(currentFile))
  }

  const getLogo = async () => {
    setIsBusy(true)
    const response = await fetch(`/get_company_logo`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

    response.json().then((result) => {
      if (response.status === 200) {
        setUploadedFileUrl(result.logo)
      } else {
        setError(result.error)
      }
    }).then(() => {
      setIsBusy(false)
    })

  }

  useEffect(() => {
    getLogo()
  }, [])

  return (
    <div className="logo-upload">
      {isBusy && <div className="spinner-wrapper"><Spinner /></div>}
      <Row>
        <Col xs="12" sm="6">
          <Dropzone onDrop={acceptedFiles => onDropHandler(acceptedFiles)} disabled={isBusy}>
            {({getRootProps, getInputProps}) => (
              <section className="dropzone_logo">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className="button button-default-outlined">Select file</div>
                  <div className="text">Drop files gere...
                    <div className="icon"><img src={UploadIcon} className="img-responsive" alt="upload icon" /></div>
                  </div>
                </div>
              </section>
            )}
          </Dropzone>
        </Col>
        <Col xs="12" sm="6">
          {uploadedFileUrl && (
            <div className="logo-upload-preview">
              <img src={uploadedFileUrl} className="img-responsive" alt="uploaded img" />
              <Button
                color="link"
                className="button-close"
                onClick={() => {
                  setUploadedFileUrl("")
                  setFile({})
                }}
              />
            </div>
          )}
        </Col>
      </Row>
      <div className="logo-upload-files">
        <div className="logo-upload-list">
          <div className="logo-upload-item">
            <div className="icon">
              <img src={ExclamationCircle} className="img-responsive" alt="exclamation icon" />
            </div>
            Files supported are JPG, PNG, GIF, up to 10MB file size
          </div>
          <div className="logo-upload-item">
            <div className="icon">
              <img src={ExclamationCircle} className="img-responsive" alt="exclamation icon" />
            </div>
            Recommended dimensions are 275x55
          </div>
        </div>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  )
}

LogoUpload.propTypes = {}

export default LogoUpload